import { render, staticRenderFns } from "./go-Details.vue?vue&type=template&id=4cd9a7b4&scoped=true&"
import script from "./go-Details.vue?vue&type=script&lang=js&"
export * from "./go-Details.vue?vue&type=script&lang=js&"
import style0 from "./go-Details.vue?vue&type=style&index=0&id=4cd9a7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9a7b4",
  null
  
)

export default component.exports